import React from "react";
import InlineLoader from "../common/InlineLoader";
import EmptyState from "../common/EmptyState";
import "./ArgumentDNA.scss";

const ArgumentDNA = ({
  dnaQuestions,
  dnaLoading,
  dnaResult,
  dnaResultLoading,
  quizStep,
  setQuizStep,
  handleDnaAnswer,
  resetDnaQuiz,
  goToCA,
}) => {
  const getMinisterInitials = (name) => {
    if (!name) return "";
    const parts = name.trim().split(/\s+/);
    const first = parts[0]?.[0] || "";
    const last = parts.length > 1 ? parts[parts.length - 1]?.[0] : "";
    return (first + last).toUpperCase();
  };

  return (
    <div className="quiz-container">
      <div className="pub-section-lbl" style={{ color: "#12308c", fontWeight: 700, paddingTop: 16 }}>
        <i className="ti ti-sparkles"></i> Thinker In You
      </div>
      <div className="quiz-card">
        <div className="quiz-body">
          {dnaLoading && <InlineLoader label="Loading today's quiz…" />}
          {!dnaLoading && dnaQuestions.length === 0 && (
            <EmptyState label="No Thinker In You quiz available right now." />
          )}

          {!dnaLoading && dnaQuestions.length > 0 && (
            <>
              {quizStep <= dnaQuestions.length - 1 && (
                <div className="quiz-news-highlight">
                  <span className="quiz-news-eyebrow"><i className="ti ti-news"></i> Today's Story</span>
                  <p className="quiz-news-text">{dnaQuestions[0].NewsTitle}</p>
                </div>
              )}

              {quizStep === -1 && (
                <div className="quiz-intro">
                  <h3>Which Thinker Do You Argue Like?</h3>
                  <p>Answer a few quick questions based on today's news story above — an honest read on which thinker's instinct actually matches yours.</p>
                  <button className="quiz-start-btn" onClick={() => setQuizStep(0)}>
                    Reveal The Thinker In You →
                  </button>
                </div>
              )}

              {quizStep >= 0 && quizStep < dnaQuestions.length && (
                <>
                  <div className="quiz-progress">
                    {dnaQuestions.map((_, i) => (
                      <span key={i} className={i <= quizStep ? "on" : ""}></span>
                    ))}
                  </div>
                  <div className="quiz-q">{dnaQuestions[quizStep].Question}</div>
                  <div className="quiz-opts">
                    {dnaQuestions[quizStep].Options.map((o) => (
                      <button
                        className="quiz-opt"
                        key={o.Id}
                        onClick={() => handleDnaAnswer(dnaQuestions[quizStep].Id, o.Id)}
                      >
                        {o.OptionText}
                      </button>
                    ))}
                  </div>
                </>
              )}

              {quizStep === dnaQuestions.length && (
                <div className="quiz-result">
                  {dnaResultLoading && <InlineLoader label="Reading your answers…" />}
                  {!dnaResultLoading && dnaResult && (
                    <>
                      <div className="quiz-result-av">{getMinisterInitials(dnaResult)}</div>
                      <div className="quiz-result-lbl">You argue like</div>
                      <h3>{dnaResult}</h3>
                      <div className="quiz-result-btns">
                        <button className="quiz-retry-btn" onClick={resetDnaQuiz}>Retake</button>
                        {/* <button className="quiz-profile-btn" onClick={goToCA}>
                          Read {dnaResult.split(" ").pop()}'s full take →
                        </button> */}
                      </div>
                      {/* <div className="quiz-src-note">Built from today's live Thinker In You questions.</div> */}
                    </>
                  )}
                  {!dnaResultLoading && !dnaResult && (
                    <EmptyState label="Couldn't work out your result — please try again." />
                  )}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ArgumentDNA;